import { useState, useEffect } from "react";
import {
  getPartyList,
  getAllPartyList,
  getRegions,
} from "../../../../../api/ph-api";
import PartyList from "../../../../../../components/partylist/PartyListWidget";

export const getStaticProps = async () => {
    let regionList = await getRegions();
    let partyList = await getPartyList();
    let allPartyList = await getAllPartyList();
  
    if (!regionList || !partyList || !allPartyList) {
      return {
        props: { partyList, allPartyList, regionList },
        revalidate: 1
      }
    }
  
    return {
      props: { partyList, allPartyList, regionList }
    };
  };

const EmbedPartyListPartialResults = ({ partyList, allPartyList, regionList }) => {
  const [url, setUrl] = useState("");
  
  useEffect(() => {
    setUrl(`${window.location.origin}/elections/2022/races/party-list/overseas-absentee-voting-results`);
  }, []);

  return (
    <PartyList 
      view="overseas-absentee-voting-results"
      path="party-list"
      regionList={regionList?.results}
      partyList={partyList} 
      allPartyList={allPartyList} 
      url={url}
      isEmbed="true"
    />
  );
}

export default EmbedPartyListPartialResults;
